module.exports = __webpack_public_path__ + "static/media/kitchen-background.ec1f4a86.jpg";